import { IncomeType } from "shared/types";
import { CombinedIncomeSubStep } from "../../constants";
import { FlowStep } from "./types";
import {
  Briefcase02Icon,
  Mail02Icon,
  PieChart07Icon,
  PiggyBankIcon
} from "@hugeicons-pro/core-stroke-rounded";

export const combinedIncomeScreenFlows: Record<
  CombinedIncomeSubStep,
  FlowStep
> = {
  [CombinedIncomeSubStep.IncomeStatus]: {
    next: [
      {
        condition: (data) => !!data?.hasIncome,
        target: CombinedIncomeSubStep.SelectIncomeType
      },
      {
        condition: (data) => !data?.hasIncome,
        target: CombinedIncomeSubStep.NoIncomeReason
      }
    ]
  },
  [CombinedIncomeSubStep.NoIncomeReason]: {
    next: CombinedIncomeSubStep.HousingAssistance,
    back: CombinedIncomeSubStep.IncomeStatus
  },
  [CombinedIncomeSubStep.SelectIncomeType]: {
    next: [
      {
        condition: (data) =>
          !!data?.incomeType &&
          [
            IncomeType.Employment,
            IncomeType.SelfEmployment,
            IncomeType.OfferLetter
          ].includes(data.incomeType),
        target: CombinedIncomeSubStep.CompanyDetails
      },
      {
        condition: (data) =>
          !!data?.incomeType && data.incomeType === IncomeType.OtherIncome,
        target: CombinedIncomeSubStep.OtherIncomeDetails
      }
    ],
    back: [
      {
        condition: (data) => !data?.hasIncome,
        target: CombinedIncomeSubStep.IncomeStatus
      },
      {
        condition: (data) => !!data?.hasIncome,
        target: CombinedIncomeSubStep.AddAnotherIncome
      }
    ]
  },
  [CombinedIncomeSubStep.CompanyDetails]: {
    next: [
      {
        condition: (data) =>
          !!data?.incomeType && data.incomeType === IncomeType.SelfEmployment,
        target: CombinedIncomeSubStep.PreTaxIncome
      },
      {
        condition: (data) =>
          !!data?.incomeType &&
          [IncomeType.Employment, IncomeType.OfferLetter].includes(
            data.incomeType
          ),
        target: CombinedIncomeSubStep.SupervisorDetails
      }
    ],
    back: CombinedIncomeSubStep.SelectIncomeType
  },
  [CombinedIncomeSubStep.SupervisorDetails]: {
    next: CombinedIncomeSubStep.PreTaxIncome,
    back: CombinedIncomeSubStep.CompanyDetails
  },
  [CombinedIncomeSubStep.OtherIncomeDetails]: {
    next: CombinedIncomeSubStep.PreTaxIncome,
    back: CombinedIncomeSubStep.SelectIncomeType
  },
  [CombinedIncomeSubStep.PreTaxIncome]: {
    next: [
      {
        condition: (data) =>
          !!data?.incomeType && data.incomeType === IncomeType.OfferLetter,
        target: CombinedIncomeSubStep.DocumentUpload
      },
      {
        condition: (data) =>
          !!data?.incomeType && data.incomeType !== IncomeType.OfferLetter,
        target: CombinedIncomeSubStep.SelectDocumentType
      }
    ],
    back: [
      {
        condition: (data) =>
          !!data?.incomeType &&
          [IncomeType.Employment, IncomeType.OfferLetter].includes(
            data.incomeType
          ),
        target: CombinedIncomeSubStep.SupervisorDetails
      },
      {
        condition: (data) =>
          !!data?.incomeType && data.incomeType === IncomeType.SelfEmployment,
        target: CombinedIncomeSubStep.CompanyDetails
      },
      {
        condition: (data) =>
          !!data?.incomeType && data.incomeType === IncomeType.OtherIncome,
        target: CombinedIncomeSubStep.OtherIncomeDetails
      }
    ]
  },
  [CombinedIncomeSubStep.SelectDocumentType]: {
    next: CombinedIncomeSubStep.DocumentUpload,
    back: CombinedIncomeSubStep.PreTaxIncome
  },
  [CombinedIncomeSubStep.DocumentUpload]: {
    next: CombinedIncomeSubStep.AddAnotherIncome,
    back: [
      {
        condition: (data) => data?.incomeType === IncomeType.OfferLetter,
        target: CombinedIncomeSubStep.PreTaxIncome
      },
      {
        condition: (data) => data?.incomeType !== IncomeType.OfferLetter,
        target: CombinedIncomeSubStep.SelectDocumentType
      }
    ]
  },
  [CombinedIncomeSubStep.AddAnotherIncome]: {
    next: CombinedIncomeSubStep.HousingAssistance
  },
  [CombinedIncomeSubStep.HousingAssistance]: {
    next: CombinedIncomeSubStep.Completed,
    back: [
      {
        condition: (data) => !!data?.hasIncome,
        target: CombinedIncomeSubStep.AddAnotherIncome
      }
    ]
  },
  [CombinedIncomeSubStep.Completed]: {
    // End state
  }
};

export const incomeTypeOptions = [
  {
    type: IncomeType.Employment,
    label: "Employment",
    icon: Briefcase02Icon
  },
  {
    type: IncomeType.SelfEmployment,
    label: "Self-employment",
    icon: PieChart07Icon
  },
  {
    type: IncomeType.OtherIncome,
    label: "Other income",
    icon: PiggyBankIcon
  },
  {
    type: IncomeType.OfferLetter,
    label: "Offer letter",
    icon: Mail02Icon
  }
];
